import * as Logger from 'js-logger';
import { EMPTY } from 'rxjs';
import { setupLogging } from '@app/shared/logging';
import { TimeServiceBase } from '@app/shared/time.service.base';
import { environment } from '@environment/environment';
var ɵ0 = function (timeService) { return function () {
    setupLogging(timeService, environment.production ? Logger.INFO : Logger.DEBUG);
    return EMPTY;
}; };
var LoggingModule = /** @class */ (function () {
    function LoggingModule() {
    }
    return LoggingModule;
}());
export { LoggingModule };
export { ɵ0 };
